import { SearchInput } from '@billy/design-system'
import React, { ChangeEvent, ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useSegment } from '../../../../../../../../hooks'
import { defaultContactsQuery, useContactsListFilters } from '../../../../../../hooks/useContactsListFilters'
import { useContactType } from '../../../../contexts/contactTypeContext'

export const ContactsSearch = (): ReactElement => {
  const { t } = useTranslation()
  const { track } = useSegment()
  const [{ searchQuery }, setFilters] = useContactsListFilters()
  const { isCustomer } = useContactType()

  const isSearchInputFocused = !!searchQuery

  const handleChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      if (isCustomer) {
        track('XXX - Invoicing Success - Customers List - Search typed')
      }
      setFilters({ page: defaultContactsQuery.page, searchQuery: event.target.value || undefined })
    },
    [isCustomer, setFilters, track],
  )

  const handleClear = useCallback(() => {
    setFilters({ page: defaultContactsQuery.page, searchQuery: undefined })
  }, [setFilters])

  return (
    <SearchInput
      focused={isSearchInputFocused}
      onChangeDebounced={handleChange}
      onClear={handleClear}
      placeholder={`${t('search')}...`}
      value={searchQuery}
    />
  )
}
